export default {
    Email: 'E-mail',
    ConfirmEmail: 'Confirmar E-mail',
    Password: 'Senha',
    Verificationcode: 'Código de verificação',
    AlreadyhaveaHitPawaccountLogin: 'Já tem uma conta de HitPaw? Login',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'Ao se registrar, você concorda com nossos Serviços de Uso e Política de Privacidade',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'Ao fazer login, você concorda com nossos Serviços de Uso e Política de Privacidade',
    Byproceedingyouagreetoour: 'Ao se registrar/Ao fazer login, você concorda com nossos ',
    ServicesofUse: 'Serviços de Uso',
    and: ' e ',
    PrivacyPolicy: 'Política de Privacidade',
    last: '.',
    TheEmailformatisincorrect: 'O formato do e-mail é incorreto',
    Pleaseenterthesameemailinbothfields: 'Por favor, digite o mesmo e-mail em ambos os campos.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'A senha deve ter de 8 a 50 caracteres e conter pelo menos duas categorias entre as seguintes: número, letra ou caracter especial.',
    Incorrectverificationcode: 'Código de verificação incorreto',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'O e-mail foi registrado, por favor, escolha outro e-mail.',
    Cannotbeemptyhere: 'Aqui não pode estar vazio.',
    Rememberme: 'Lembre-se de mim',
    ForgotPassword1: 'Esqueceu Senha?',
    NotaregistereduseryetSignUp: 'Ainda não é um usuário registrado? Registrar-se',
    Notaregistereduseryet1: 'Ainda não é um usuário registrado? ',
    Notaregistereduseryet2: 'Registrar-se',
    NoaccountfoundwiththatEmailaddress: 'Nenhuma conta encontrada com esse endereço de e-mail',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'Seu endereço de e-mail ou senha é incorreta. Por favor, tente novamente.',
    ForgotPassword2: 'Esqueceu Senha',
    GetVerificationCode: 'Obter Código de Verificação',
    VerifyEmail: 'Verificar E-mail',
    Ithasbeensenttoyourmailboxpleasecheckit:
        'Código foi enviado para sua caixa de e-mail, por favor, verifique-o',
    PleaseinputEmailaddress: 'Por favor, insira o endereço de e-mail',
    TheEmailisnotregistered: 'O e-mail não foi registrado',
    Invalidverificationcodepleasereenterthecorrectone:
        'Código de verificação inválido, por favor, digite novamente o código correto',
    Resetpassword: 'Redefinir senha',
    Emailaddressverificationsucceeded: 'A verificação do endereço de e-mail foi aprovada',
    Pleaseresetyourpassword: 'Por favor, redefina sua senha',
    Enteranewpassword: 'Digite uma nova senha',
    Confirm: 'Confirmar',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'A nova senha deve ter de 8 a 50 caracteres e incluir letras ou números ou uma mistura de letras + números',
    Passwordresetsuccessfully: 'Senha redefinida com sucesso',
    Name: 'Nome',
    GetCode: 'Obter Código',
    Loginsuccessful: 'Login com sucesso',
    Loginfailed: 'Login falhou',
    Signupsuccessful: 'Inscreveu-se com sucesso',
    Signupfailed: 'A inscrição falhou',
    Getpassword: 'Obter senha',
    Authorizationhasexpiredpleaseloginagain:
        'A autorização expirou, por favor, faça o login novamente.',
    Sorrysomethingwentwrongpleasetryagainlater:
        'Desculpe, algo deu errado, por favor, tente novamente mais tarde.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'Demasiados pedidos foram feitos em um curto período de tempo, por favor, tente novamente mais tarde.',
    Couldntfindyouraccountorthepasswordisincorrect:
        'Não foi encontrada sua conta, ou a senha está incorreta.',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'Você está tentando acessar uma função paga, por favor, registre-se primeiro.',
    Accessdeniedfortheunauthorizedrequest: 'Acesso recusado para o pedido não autorizado.',
    Alreadyhaveaccount: 'Já tens conta?',
    SignUpwithemail: 'Registar- se com e- mail',
    Securityverification: 'Verificação da segurança',
    Pleaseenterthecorrectemailaddress: 'Por favor, digite o endereço de e-mail correto!',
    PleaseInputverificationCode: 'Por favor, introduza o código de verificação!',
    Pleaseenterthesamepasswordinbothfields:
        'Por favor, digite a mesma senha em ambos os campos!',
    or: 'ou',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'A nova senha que você inseriu é a mesma que sua senha antiga. Digite uma senha diferente',
    YourpasswordwasincorrectPleasetryagain:
        'Sua senha é incorreta. Por favor, tente novamente.',
    reg400: 'Desculpe, algo deu errado, por favor, tente novamente mais tarde.',
    reg400223: 'O e-mail e código não correspondem, por favor verifique',
    reg400224: 'O token expirou',
    ContinuewithGoogle: 'Continuar com Google',
    ContinuewithEmail: 'Continuar com E-mail',
    LoginwithEmail: 'Iniciar sessão com E-mail',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        'Use mais de 8 caracteres e uma combinação de letras, números e símbolos (símbolos suportados: @$!%*#_~?&^)',
    ConfirmPassword: 'Confirmar a Senha',
    Pleaseloginwithemail: 'Por favor, faça login com E-mail',
    youraccount: 'Sua conta',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        'já existe. Para garantir a segurança da conta, complete a verificação primeiro.',
    500: 'Erro do lado do servidor!',
    Login: 'Fazer login',
    exceed6Times: 'Sua avaliação terminou hoje, atualize para o Pro para acessar todos os recursos premium.',
    exceed20M: 'O tamanho do arquivo para contas gratuitas não pode exceder 20 MB, atualize para o Pro para acessar todos os recursos premium.'
}